"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var shadows = {
    $1dp: function (rgb) {
        return "0px 1px 3px rgba(" + rgb + ", 0.2), 0px 2px 1px rgba(" + rgb + ", 0.12), 0px 1px 1px rgba(" + rgb + ", 0.14)";
    },
    $2dp: function (rgb) {
        return "0px 1px 5px rgba(" + rgb + ", 0.2), 0px 3px 1px rgba(" + rgb + ", 0.12), 0px 2px 2px rgba(" + rgb + ", 0.14)";
    },
    $3dp: function (rgb) {
        return "0px 1px 8px rgba(" + rgb + ", 0.2), 0px 3px 3px rgba(" + rgb + ", 0.12), 0px 3px 4px rgba(" + rgb + ", 0.14)";
    },
    $4dp: function (rgb) {
        return "0px 2px 4px rgba(" + rgb + ", 0.2), 0px 1px 10px rgba(" + rgb + ", 0.12), 0px 4px 5px rgba(" + rgb + ", 0.14)";
    },
    $6dp: function (rgb) {
        return "0px 3px 5px rgba(" + rgb + ", 0.2), 0px 1px 18px rgba(" + rgb + ", 0.12), 0px 6px 10px rgba(" + rgb + ", 0.14)";
    },
    $8dp: function (rgb) {
        return "0px 5px 5px rgba(" + rgb + ", 0.2), 0px 3px 14px rgba(" + rgb + ", 0.12), 0px 8px 10px rgba(" + rgb + ", 0.14)";
    },
    $9dp: function (rgb) {
        return "0px 5px 6px rgba(" + rgb + ", 0.2), 0px 3px 16px rgba(" + rgb + ", 0.12), 0px 9px 12px rgba(" + rgb + ", 0.14)";
    },
    $12dp: function (rgb) {
        return "0px 7px 8px rgba(" + rgb + ", 0.2), 0px 5px 22px rgba(" + rgb + ", 0.12), 0px 12px 17px rgba(" + rgb + ", 0.14)";
    },
    $16dp: function (rgb) {
        return "0px 8px 10px rgba(" + rgb + ", 0.2), 0px 6px 30px rgba(" + rgb + ", 0.12), 0px 16px 24px rgba(" + rgb + ", 0.14)";
    },
    $24dp: function (rgb) {
        return "0px 11px 15px rgba(" + rgb + ", 0.2), 0px 9px 46px rgba(" + rgb + ", 0.12), 0px 24px 38px rgba(" + rgb + ", 0.14)";
    }
};
exports.default = shadows;
//# sourceMappingURL=index.js.map